
function query(query, variables) {
    return fetch(`//${Shopify.cdnHost.replace("/cdn", "")}/api/2026-04/graphql.json`, {
        // mode: 'no-cors',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    })
    .then(r => r.json())
    .then(data => console.log('graphql response:', data));
}

function fetchCollectionByName(name) {
    return fetch(`{
        collectionByHandle(handle: "spicy") {
        products(first: 10) {
            edges {
                node {
                    id
                    title
                    description
                    images(first: 1) {
                    edges {
                        node {
                        originalSrc
                        }
                    }
                    }
                    variants(first: 1) {
                    edges {
                        node {
                        id
                        priceV2 {
                            amount
                            currencyCode
                        }
                        }
                    }
                    }
                }
            }
        }
        }
    }`);
}

const graphqlHelper = {
    query,
    fetchCollectionByName
}

window.graphqlHelper = graphqlHelper;

export {
    query,
    fetchCollectionByName
}